<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @fullMember="fullMemberApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
        <el-badge
          v-if="allow('F')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('F')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="fullMember"
          >
            {{ $l('btn_full_member') || '转正产品' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true, checkedRows: [] }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomHxSpuListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-base-hxSpu-detail',
        params: { ...params, pageType },
        query,
      })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    fullMember() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要转正的SPU',
          type: 'warning',
        })
        return
      }
      const listHxSpuCode = this.checkedRows.map((row) => row.hxSpuCode)
      this.fullMemberApi(listHxSpuCode)
    },
    async fullMemberApi(listHxSpuCode) {
      const confirm = await this.$confirm(
        '是否要转正产品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomHxSpuFullMemberApi({ listHxSpuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('转正失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '转正成功！',
        type: 'success',
      })
      this.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
